<template>
  <v-card>
    <v-card-title v-if="!isSmAndDown" class="pb-2">
      <v-layout justify-space-between row align-center>
        <h2 class="checkout-h2">Ingressos</h2>
        <v-spacer></v-spacer>
        <span
          class="secondary--text link mt-1 mr-2"
          v-if="
            sectors.length > 1 ||
              (noSectorProducts.length >= 1 && sectors.length === 1)
          "
          style="width: 28px; height: 28px;"
          @click="backToSelect"
        ></span>
        <span
          class="secondary--text link mt-1 mr-2"
          v-if="
            sectors.length > 1 ||
              (noSectorProducts.length >= 1 && sectors.length === 1)
          "
          @click="backToSelect"
          >Setores</span
        >
        <v-divider class="mx-4" vertical v-if="sectors.length >= 1"></v-divider>
        <span
          class="secondary--text link mt-1 mb-1"
          :class="isScheduledCampaign ? 'mr-4' : ''"
          v-if="(!showCode && !hasCupom) || (isScheduledCampaign && !showCode)"
          @click="handleToogleShowCode"
          >Aplicar um código</span
        >
        <div
          v-if="
            (showCode && !isCupomTracking) || (hasCupom && !isCupomTracking)
          "
          grid-list-xs
        >
          <v-layout
            row
            wrap
            v-if="hasCupom && !(isScheduledCampaign && showCode)"
          >
            <v-layout
              v-if="isValidCupomCode && !loading"
              row
              align-center
              class="success-background"
            >
              <div>
                <v-layout v-if="!isScheduledCampaign" row>
                  <span
                    style="width: 100%; border-radius: 4px; padding: 8px;"
                    class="success-text-code"
                  >
                    Código
                    <strong class="success-text-code">{{ cupomCode }}</strong>
                    aplicado!
                  </span>
                </v-layout>

                <v-layout row>
                  <span
                    style="width: 100%; border-radius: 4px; padding: 8px;"
                    class="custom-html"
                    v-html="cupomData.campaign_description"
                  ></span>
                </v-layout>
              </div>

              <div v-if="!isScheduledCampaign" class="pl-4">
                <v-btn
                  right
                  flat
                  icon
                  color="green"
                  class="mr-0"
                  @click="removeCode"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-layout>
            <v-layout
              v-else-if="!loading"
              row
              justify-space-between
              align-center
              class="red"
            >
              <span
                v-if="!cupomMessage"
                style="width: 100%; border-radius: 4px; padding: 8px;"
                class="white--text"
              >
                <v-icon class="white--text" left>warning</v-icon>
                Código
                <strong class="white--text">{{ cupomCode }}</strong> inválido ou
                esgotado.
              </span>
              <span
                v-else
                style="width: 100%; border-radius: 4px; padding: 8px;"
                class="white--text"
              >
                <v-icon class="white--text" left>warning</v-icon>
                {{ cupomMessage }}
              </span>
              <v-btn
                right
                flat
                icon
                color="white"
                class="mr-0"
                @click="removeCode"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>

          <v-layout
            row
            nowrap
            justify-space-between
            v-else-if="
              sectors || noSectorProducts || (isScheduledCampaign && showCode)
            "
            style="max-height: 60px"
          >
            <v-text-field
              outline
              label="Escreve seu código aqui"
              ref="cupomId"
              v-model="cupomCode"
              @keyup.enter="applyCode"
            ></v-text-field>
            <v-btn
              large
              depressed
              class="normal-text cst-btn mr-3"
              :class="{ 'btn-disabled': !cupomCode }"
              :color="!!cupomCode ? 'primary' : 'info'"
              @click="applyCode"
              dark
            >
              Aplicar
            </v-btn>
            <v-btn
              right
              flat
              icon
              large
              color="grey"
              class="mr-0"
              @click="showCode = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </div>
      </v-layout>
    </v-card-title>

    <v-card-title v-else class="pb-0">
      <v-layout justify-space-between row>
        <h2 class="checkout-h2 pb-3">Ingressos</h2>
        <v-spacer></v-spacer>
        <span
          class="secondary--text link mt-1 mr-2"
          v-if="
            sectors.length > 1 ||
              (noSectorProducts.length >= 1 && sectors.length === 1)
          "
          style="width: 28px; height: 28px;"
          @click="backToSelect"
        ></span>
        <span
          class="secondary--text link mt-1 mr-2"
          v-if="
            sectors.length > 1 ||
              (noSectorProducts.length >= 1 && sectors.length === 1)
          "
          @click="backToSelect"
          >Setores</span
        >
        <v-divider
          class="mx-2 mb-3"
          vertical
          v-if="
            sectors.length > 1 ||
              (noSectorProducts.length >= 1 && sectors.length === 1)
          "
        ></v-divider>
        <span
          class="secondary--text link mt-1"
          v-if="(!showCode && !hasCupom) || (isScheduledCampaign && !showCode)"
          @click="handleToogleShowCode"
          >Aplicar um código</span
        >
      </v-layout>

      <div
        v-if="(showCode && !isCupomTracking) || (hasCupom && !isCupomTracking)"
        grid-list-xs
        style="width: 100%"
      >
        <v-layout
          row
          wrap
          v-if="hasCupom && !(isScheduledCampaign && showCode)"
        >
          <v-layout
            v-if="isValidCupomCode && !loading"
            row
            justify-space-between
            align-center
            class="success-background mb-2"
          >
            <div>
              <v-layout v-if="!isScheduledCampaign" row>
                <span
                  style="width: 100%; border-radius: 4px; padding: 8px;"
                  class="success-text-code"
                >
                  Código
                  <strong class="success-text-code">{{ cupomCode }}</strong>
                  aplicado!
                </span>
              </v-layout>

              <v-layout row>
                <span
                  style="width: 100%; border-radius: 4px; padding: 8px;"
                  class="custom-html"
                  v-html="cupomData.campaign_description"
                ></span>
              </v-layout>
            </div>

            <v-btn
              v-if="!isScheduledCampaign"
              right
              flat
              icon
              color="green"
              class="mr-0"
              @click="removeCode"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
          <v-layout
            v-else-if="!loading"
            row
            justify-space-between
            align-center
            class="red mb-2"
          >
            <span
              v-if="!cupomMessage"
              style="width: 100%; border-radius: 4px; padding: 8px;"
              class="white--text"
            >
              <v-icon class="white--text" left>warning</v-icon>
              Código
              <strong class="white--text">{{ cupomCode }}</strong> inválido ou
              esgotado.
            </span>
            <span
              v-else
              style="width: 100%; border-radius: 4px; padding: 8px;"
              class="white--text"
            >
              <v-icon class="white--text" left>warning</v-icon>
              {{ cupomMessage }}
            </span>
            <v-btn
              right
              flat
              icon
              color="white"
              class="mr-0"
              @click="removeCode"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>

        <v-layout
          row
          nowrap
          justify-space-between
          v-else-if="sectors || noSectorProducts"
        >
          <v-text-field
            outline
            label="Escreve seu código aqui"
            ref="cupomId"
            v-model="cupomCode"
            @keyup.enter="applyCode"
          ></v-text-field>
          <v-btn
            large
            depressed
            class="normal-text cst-btn"
            :class="{ 'btn-disabled': !cupomCode }"
            :color="!!cupomCode ? 'primary' : 'info'"
            @click="applyCode"
            dark
          >
            Aplicar
          </v-btn>
        </v-layout>
      </div>
    </v-card-title>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      showCode: false,
      code: '',
    };
  },
  computed: {
    ...mapGetters({
      sectors: 'sectors',
      noSectorProducts: 'noSectorProducts',
      showDefault: 'showDefault',
      loading: 'loading',
      cupomMessage: 'cupomMessage',
      cupomData: 'cupomData',
    }),
    cupomCode: {
      get() {
        return this.$store.getters.cupomCode;
      },
      set(value) {
        this.$store.dispatch('setCupomCode', value);
      },
    },
    isValidCupomCode() {
      return this.$store.getters.isValidCupomCode;
    },
    isCupomTracking() {
      return this.$store.getters.isCupomTracking;
    },
    hasCupom() {
      return this.$store.getters.hasCupom;
    },
    selectedSector() {
      return this.$store.getters.selectedSector;
    },
    isScheduledCampaign() {
      return (
        this.cupomData &&
        this.cupomData.campaign_type &&
        this.cupomData.campaign_type === 'programada'
      );
    },
  },
  mounted() {
    if (this.$store.getters.urlCupom) this.applyUrlCode();
  },
  methods: {
    applyUrlCode() {
      this.showCode = true;
      this.cupomCode = this.$store.getters.urlCupom;
      this.$store.dispatch('setUrlCupom', null);
      this.applyCode();
    },
    backToSelect() {
      this.$store.dispatch('backToSelection');
    },
    setShowCode() {
      this.showCode = !this.showCode;
      if (this.isCupomTracking) {
        this.$store.commit('SET_IS_CUPOM_TRACKING', false);
        this.$store.commit('SET_HAS_CUPOM', false);
        this.cupomCode = null;
        this.showCode = true;
      }
      if (this.showCode && !this.hasCupom) {
        setTimeout(this.setFocus, 200);
      }
    },
    setFocus() {
      this.$refs.cupomId.focus();
    },
    async applyCode() {
      if (this.cupomCode) {
        await this.$store.dispatch('setSectorsList', true);
        // this.$store.dispatch('setSectorsList', true)
        localStorage.setItem('cupomCode', this.cupomCode);
        localStorage.setItem('cupomCodeEvent', this.eventID);
        let updatedSelectedSector = this.sectors.find(
          s => s.codigo === this.selectedSector.codigo
        );
        if (updatedSelectedSector)
          this.$store.dispatch('setSelectedSector', updatedSelectedSector);
      }
    },
    removeCode() {
      this.cupomCode = '';
      localStorage.setItem('cupomCode', this.cupomCode);
      localStorage.setItem('cupomCodeEvent', null);
      this.$store.dispatch('setSectorsList');
      this.$store.commit('SET_IS_CUPOM_TRACKING', false);
    },

    handleToogleShowCode() {
      this.cupomCode = '';
      this.showCode = !this.showCode;
    },
  },
};
</script>
<style scoped>
.link {
  cursor: pointer;
}
.cst-btn {
  height: 56px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.success-background {
  background-color: rgba(0, 166, 90, 0.08);
}
.success-text-code {
  color: #00a65a;
}
</style>

<style lang="stylus">
@import '~@/assets/product/productsPanel.styl'
@import "~@/assets/product/productTypes.styl"
</style>
